import { useEffect, useState, Fragment } from "react";
import dynamic from "next/dynamic";
import { motion } from "framer-motion";
import {
	isInternetExplorer,
	get_browser,
} from "../../../../utils";
import { getBlockId } from "../../../../utils/forms/form.fields.utils";

const LazyLoad = dynamic(() => import('../../Image/LazyLoad'));
let isIE = false;

if (typeof window !== "undefined") {
	//checking if browser is IE
	isIE = isInternetExplorer(get_browser(window.navigator.userAgent));
}

const ProductColours = props => {
	const { block } = props;
	const [activeIndex, setActiveIndex] = useState(0);
	const [prevIndex, setPrevIndex] = useState(0);
	const [animPosition, setAnimPosition] = useState("left");

	const createCarousel = () => {
		const carHolder = document.getElementsByClassName("colourHolder")[0];
		const car = document.getElementsByClassName("car")[0];
		const carDetails = {
			width: car.offsetWidth,
			height: car.offsetHeight
		};

		if (carDetails.height < 1000) //IE doesnt get correct value on 1st load. If so use hardcoded 500px
		{
			carHolder.style.height = `${carDetails.height}px`;
		}
		else {
			carHolder.style.height = "500px";
		}
	};

	const handleColourClick = i => {
		setPrevIndex(activeIndex);
		setActiveIndex(i);
	};

	const getPose = i => {
		let retVal = "";

		if (prevIndex < activeIndex) { 	// Right to Left
			if (activeIndex === i) {
				retVal = "enterRight"
			} else if (prevIndex === i) {
				retVal = "exitLeft";
			} else {
				if (activeIndex > i) {
					retVal = "ignoreLeft";
				} else {
					retVal = "ignoreRight";
				}
			}
		} else {						// Left to Right
			if (activeIndex === i) {
				retVal = "enterLeft"
			} else if (prevIndex === i) {
				retVal = "exitRight";
			} else {
				if (activeIndex > i) {
					retVal = "ignoreLeft";
				} else {
					retVal = "ignoreRight";
				}
			}
		}

		return retVal;
	};

	useEffect(() => {
		// Get size of the first image and set it to the size of the container.
		// Add an event listener for resize.
		createCarousel();
		setTimeout(() => {
			createCarousel();
		}, 300)
		window.addEventListener("resize", createCarousel);
		return () => {
			window.removeEventListener("resize", createCarousel);
		};
	}, []);

	const colour = {
		enterRight: {
			x: 0,
			transition: { type: "tween", duration: 1, ease: "linear", from: "100%" }
		},
		exitRight: {
			x: "100%",
			transition: { type: "tween", duration: 1, ease: "linear" }
		},
		enterLeft: {
			x: 0,

			transition: { type: "tween", duration: 1, ease: "linear", from: "-100%" }
		},
		exitLeft: {
			x: "-100%",
			transition: { type: "tween", duration: 1, ease: "linear" }
		},
		ignoreLeft: {
			x: "-100%",
			transition: { duration: 0.000001 }
		},
		ignoreRight: {
			x: "100%",
			transition: { duration: 0.000001 }
		}
	};

	const colourIE = {
		enterRight: {
			x: 0,
			transition: { from: "100%" }
			// transition: { type: "tween", duration: 1, ease: "linear", from: "100%" }
		},
		exitRight: {
			x: "100%",
			// transition: { type: "tween", duration: 1, ease: "linear" }
		},
		enterLeft: {
			x: 0,
			transition: { from: "-100%" }
			// transition: { type: "tween", duration: 1, ease: "linear", from: "-100%" }
		},
		exitLeft: {
			x: "-100%",
			// transition: { type: "tween", duration: 1, ease: "linear" }
		},
		ignoreLeft: {
			x: "-100%",
			transition: { duration: 0.000001 }
		},
		ignoreRight: {
			x: "100%",
			transition: { duration: 0.000001 }
		}
	};

	const colourName = {
		enter: {
			opacity: 1,
			height: 'auto'
		},
		exit: {
			opacity: 0,
			height: 0
		}
	};

	return (
		<div className="productColours clear mt32px" id={getBlockId(block)}>
			<h2 className="cbTitle">{block.data.title}</h2>
			<div className="productColoursHolder">
				<div className="colourHolder">
					{block.data.children.map((car, i) => {
						return (
							<motion.div
								className="car"
								key={`${car.data.image.id}-${i}`}
								animate={getPose(i)}

								variants={isIE ? colourIE : colour} //use tween or not
							>
								{car.data.image.length > 1 ? (
									<Fragment>
										<img
											src={car.data.image[0].url}
											alt=""
											className="responsive-img placeholder"
										/>
										<img
											src={car.data.image[0].url}
											alt=""
											className="responsive-img carImage static"
										/>
										<img
											src={car.data.image[1].url}
											alt=""
											className="responsive-img carImage hover"
										/>
									</Fragment>
								) : (
									<LazyLoad className="center" image={car.data.image[0]} alt="" />
								)}
							</motion.div>
						);
					})}
				</div>
			</div>
			<div className="colours">
				{block.data.children.map((car, i) => {
					return (
						<div
							className={`colour ${activeIndex === i ? "active" : ""
								}`}
							key={`colour-${car.data.image[0].id}-${i}`}
							onClick={() => {
								handleColourClick(i);
							}}
						>
							<div
								className="left"
								style={{
									backgroundColor: car.data.mainColor
								}}
							></div>
							<div
								className="right"
								style={{
									backgroundColor: car.data.secondaryColor
								}}
							></div>
						</div>
					);
				})}
			</div>
			<div className="colourName  mt0px">
				{block.data.children.map((car, i) => {
					return (
						<motion.div
							animate={activeIndex === i ? 'enter' : 'exit'}
							initial="exit"
							variants={colourName}
							key={`colour-name-${car.data.image[0].id}-${i}`}
						>
							<p className="title ">
								{car.data.title}
							</p>
							<p className="type">
								{car.data.colourType}
							</p>
						</motion.div>
					);
				})}
			</div>
		</div>
	);
};

export default ProductColours;